import { useMemo } from 'react';
import { FieldOption, RenderPreference } from './types';

/**
 * Hook for determining field rendering logic based on options count and preference
 * @param options - Array of field options
 * @param renderPreference - User preference for rendering style
 * @param threshold - Threshold for switching between compact and expanded rendering
 * @returns Object with rendering decisions and item count
 */
export const useFieldLogic = (
  options: FieldOption[],
  renderPreference: RenderPreference,
  threshold: number
) => {
  return useMemo(() => {
    const itemCount = options?.length || 0;
    let useCompactControl: boolean;

    switch (renderPreference) {
      case 'compact':
        useCompactControl = true; // select/multiselect
        break;
      case 'expanded':
        useCompactControl = false; // radio/checkbox
        break;
      case 'auto':
      default:
        useCompactControl = itemCount > threshold;
        break;
    }

    return { useCompactControl, itemCount };
  }, [options, renderPreference, threshold]);
};
